import translator from 'american-british-english-translator';

// Apply the capitalization pattern of `original` onto `replacement`.
function matchCase(original, replacement) {
  if (!original) return replacement;
  if (original === original.toUpperCase()) return replacement.toUpperCase();
  if (original[0] === original[0].toUpperCase()) {
    return replacement.charAt(0).toUpperCase() + replacement.slice(1);
  }
  return replacement;
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/**
 * Detect American spellings in `value` and build a British-spelled suggestion.
 * Returns { suggestion, changes }:
 *   - suggestion: the corrected string (case-preserved), or null if nothing to change
 *   - changes: [{ from, to }] list of American -> British word pairs found
 * Non-dictionary words (domain jargon, codes) are left untouched.
 */
export function checkUkSpelling(value) {
  if (!value || typeof value !== 'string') return { suggestion: null, changes: [] };

  let analysis;
  try {
    analysis = translator.translate(value, { american: true, spelling: true });
  } catch (e) {
    return { suggestion: null, changes: [] };
  }

  const changes = [];
  Object.values(analysis || {}).forEach((lineItems) => {
    (lineItems || []).forEach((item) => {
      Object.entries(item).forEach(([word, info]) => {
        if (info && info.details && typeof info.details === 'string') {
          changes.push({ from: word, to: info.details });
        }
      });
    });
  });

  if (changes.length === 0) return { suggestion: null, changes: [] };

  let suggestion = value;
  changes.forEach(({ from, to }) => {
    const re = new RegExp(`\\b${escapeRegExp(from)}\\b`, 'gi');
    suggestion = suggestion.replace(re, (match) => matchCase(match, to));
  });

  return { suggestion: suggestion === value ? null : suggestion, changes };
}
